import createTsdApi from "../../../client-api/createTsdApi";
import {
  SupplierInvoiceItem,
  SupplierInvoiceItemCreateParams,
  SupplierInvoiceItemQueryParams,
  SupplierInvoiceItemUpdateParams,
} from "../../../entities/SupplierInvoiceItem/supplierInvoiceItem";
import { TsdSearchParam } from "../fetch";
import dayjs from "dayjs";

const supplierInvoiceItemApi = createTsdApi<
  SupplierInvoiceItem,
  SupplierInvoiceItemQueryParams,
  SupplierInvoiceItemCreateParams,
  SupplierInvoiceItemUpdateParams
>("supplier-invoice-items", (params) => {
  const search: TsdSearchParam<SupplierInvoiceItemQueryParams>[] = [];

  ({
    poNumbers: (() => {
      if (typeof params.poNumbers !== "undefined") {
        params.poNumbers.forEach((poNumber) =>
          search.push({ key: "poNumbers", value: poNumber })
        );
      }
    })(),
    supplierInvoiceIds: (() => {
      if (typeof params.supplierInvoiceIds !== "undefined") {
        params.supplierInvoiceIds.forEach((id) =>
          search.push({ key: "supplierInvoiceIds", value: String(id) })
        );
      }
    })(),
    deliveryDateGte: (() => {
      if (typeof params.deliveryDateGte !== "undefined") {
        search.push({
          key: "deliveryDateGte",
          value: dayjs()
            .fromTsdDateFormat(params.deliveryDateGte)
            .format("YYYY-MM-DD"),
        });
      }
    })(),
    deliveryDateLte: (() => {
      if (typeof params.deliveryDateLte !== "undefined") {
        search.push({
          key: "deliveryDateLte",
          value: dayjs()
            .fromTsdDateFormat(params.deliveryDateLte)
            .format("YYYY-MM-DD"),
        });
      }
    })(),
    supplierIds: (() => {
      if (typeof params.supplierIds !== "undefined") {
        params.supplierIds.forEach((id) =>
          search.push({ key: "supplierIds", value: String(id) })
        );
      }
    })(),
    associatedJobIds: (() => {
      if (typeof params.associatedJobIds !== "undefined") {
        params.associatedJobIds.forEach((id) =>
          search.push({ key: "associatedJobIds", value: String(id) })
        );
      }
    })(),
    limit: (() => {
      if (typeof params.limit !== "undefined") {
        search.push({ key: "limit", value: String(params.limit) });
      }
    })(),
    offset: (() => {
      if (typeof params.offset !== "undefined") {
        search.push({ key: "offset", value: String(params.offset) });
      }
    })(),
  }) satisfies {
    [key in keyof Required<SupplierInvoiceItemQueryParams>]: void | undefined;
  };

  return search;
});

export default supplierInvoiceItemApi;
